import React from 'react'
import {Group, Image} from 'react-konva'
import {handle, useEvent} from '../events'

import rocketShip from './broken_rocket.png'
import left from './part_left_side.png'
import right from './part_right_side.png'
import topLeft from './panel_top_left.png'
import topRight from './panel_top_right.png'
import cone from './panel_top_rocket.png'
import center from './center_piece.png'
import bottomCenter from './panel_bottom_center.png'
import bottomLeft from './panel_bottom_left.png'
import bottomRight from './panel_bottom_right.png'
import bottomEdge from './panel_bottom_edge.png'
import exhaust from './panel_bottom_exhaust.png'
import leftWing from './panel_wing_left.png'
import leftFin from './panel_fin_left.png'
import rightFin from './panel_fin_right.png'
import rightWing from './panel_wing_right.png'

import {useSpring} from 'react-spring'

import useImage from 'use-image'
import {getState} from '../game-surface'
import {addGameObject, createGameObject} from '../system'
import {genericSprite, lerp, offset, register} from '../utils'
import {part} from './part'
import {moving} from '../system/moving'
import {sprite} from '../system/sprite'
import {flicker} from './flicker'
import {getScaleFactor} from '../proportional'
import {explode} from '../explosion'
import {Sine} from '../easing'

function Sprite() {
    let [image] = useImage(rocketShip)
    useEvent('startGame', () => {
        this.$.setState('launch')
    })
    useEvent('readyState', () => {
        this.$.setState('idle')
    })
    useEvent('gameOver', () => {
        this.$.setState('gameOver')
    })
    useEvent('resetGame', () => {
        this.$.setState('idle')
    })

    const scaleFactor = lerp(0, 1, (getState().height - 40) / 50)

    const props = useSpring({
        offsetY: Math.random() * 130 * scaleFactor,
        rotate: (Math.random() * 10 - 5) * scaleFactor,
        config: {mass: 3, tension: 250, friction: 30},
    })
    this.$.transform.rotation = props.rotate.getValue()
    this.$.transform.y = props.offsetY.getValue()

    return (
        <Group>
            {image && (
                <Image
                    x={-image.width / 2 + 4}
                    y={-image.height / 2 + 6}
                    // scaleX={0.6} scaleY={0.6}
                    image={image}
                />
            )}
        </Group>
    )
}

export const rocket = register('rocket', {
    initialize() {
        getState().rocket = this.$
        handle('resetGame', () => {
            getState().height = 0
            getState().rocketSpeed = 0
            this.t = 0
            this.speed = 0
            this.$.setState('idle')
        })
        this.$.parts = this.parts = []
        this.speed = 0
        this.t = 0
        this.mountPoints = this.mountPoints || []
        this.$.addChild(
            (this.flame = createGameObject({}, {flicker, sprite}))
        )
        for (let mountPoint of this.mountPoints) {
            this.parts.push(
                this.$.addChild(
                    createGameObject(
                        {x: mountPoint.x, y: mountPoint.y, mountPoint},
                        {
                            moving,
                            part,
                            ...sprite.config({
                                Sprite: genericSprite(mountPoint.image),
                            }),
                        }
                    )
                )
            )
        }
    },
    postInitialize() {
        this.$.setState('idle')
    },
    states: {
        idle: {
            enter() {
                this.$.rotation = 0
                this.flame.visible = false
            },
            methods: {
                Update(dt) {
                    this.$.scale = lerp(0.3, 0.8, getState().height / 300)
                    this.$.y = lerp(
                        (window.innerHeight - 200) / getScaleFactor(),
                        600,
                        getState().height / 100
                    )
                },
            },
        },
        gameOver: {
            enter() {
                this.t = 0
            },
            methods: {
                Update(dt) {
                    this.t += dt / 4
                    this.$.y = lerp(500, 2000, lerp(0, 1, Sine.In(this.t)))
                    this.$.scale = lerp(0.7, 0.5, lerp(0, 1, Sine.In(this.t)))
                    this.speed = Math.min(1, this.speed + dt / 16)
                    getState().rocketSpeed = this.speed
                },
            },
        },
        launch: {
            enter() {
                explode(offset(this.$.position(), 0, 130), false)
                explode(offset(this.$.position(), 0, 130), false)
                explode(offset(this.$.position(), -100, 150), false)
                explode(offset(this.$.position(), 70, 170), false)
                explode(offset(this.$.position(), 20, 130), false)
                explode(offset(this.$.position(), -50, 230), false)
                explode(offset(this.$.position(), -100, 120), false)
                explode(offset(this.$.position(), 170, 90), false)
                setTimeout(() => {
                    this.flame.visible = true
                    this.$.setState('playing')
                }, 250)
                getState().speed = 1
            },
        },
        playing: {
            enter() {
                this.flame.visible = true
            },
            methods: {
                Update(dt) {
                    this.$.y = lerp(
                        (window.innerHeight - 200) / getScaleFactor(),
                        500,
                        getState().height / 100
                    )
                    this.$.scale = lerp(0.3, 0.7, getState().height / 300)
                    this.speed = Math.min(1, this.speed + dt / 16)
                    getState().rocketSpeed = this.speed
                },
            },
        },
    },
})

handle('initializeGame', () => {
    addGameObject(
        {x: 620, y: 600, scale: 0.8, opacity: 0.8},
        {
            sprite: {Sprite},
            ...rocket.config({
                mountPoints: [
                    {x: 5, y: -10, name: 'central', image: center},
                    {x: -150, y: -135, name: 'left', image: left},
                    {x: 155, y: -145, name: 'right', image: right},
                    {
                        x: 5,
                        y: 145,
                        name: 'lower-central',
                        image: bottomCenter,
                    },
                    {
                        x: -105,
                        y: 130,
                        name: 'left-lower-central',
                        image: bottomLeft,
                    },
                    {
                        x: 110,
                        y: 130,
                        name: 'right-lower-central',
                        image: bottomRight,
                    },
                    {x: -65, y: -415, name: 'top-left', image: topLeft},
                    {x: 87, y: -415, name: 'top-right', image: topRight},
                    {x: 10, y: -570, name: 'cone', image: cone},
                    {x: 165, y: 360, name: 'right-fin', image: rightFin},
                    {x: -170, y: 360, name: 'left-fin', image: leftFin},
                    {x: -138, y: 200, name: 'left-strut', image: leftWing},
                    {x: 135, y: 200, name: 'right-strut', image: rightWing},
                    {x: -0, y: 252, name: 'bottom-edge', image: bottomEdge},
                    {x: -5, y: 314, name: 'bottom-edge', image: exhaust},
                ],
            }),
        }
    )
})

handle('startGame', (state) => {
    state.score = 0
    state.height = 0
})
